import { render, staticRenderFns } from "./TreeData.vue?vue&type=template&id=4e728e22&"
import script from "./TreeData.vue?vue&type=script&lang=ts&"
export * from "./TreeData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports